import React from "react"
import Helmet from 'react-helmet';

export const Pre = ({
  children,
}) => {
  const options = children.props.options ? JSON.parse(children.props.options) : {}

  return (
    <>
      <Helmet>
        <link rel="stylesheet" href="/libs/prism.css" />
        <script src="/libs/prism.js" />
      </Helmet>

      <pre
        data-line={options.select}
        data-start={options.start}
        className="line-numbers"
      >
        {children}
      </pre>

    </>
  )
}

// export const Code = ({
//   children,
//   ...rest
// }) => {
//   console.log('Code', { children, ...rest });
//   return (
//     <code {...rest}>{children}</code>
//   )
// }
